import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { useNotification } from '@/shared/ui'
import { DateTime } from 'ts-luxon'

/**
 * Функция получения списка шаблонов
 */
export const useLoadImportPassportTemplate = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_import_passport_template'],
    queryFn: () => http.get(`/inventory/import-template`),
    retry: false,
  })
}

/**
 * Функция отправки данных на сервер
 */
export const useSendImportPassport = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: FormData) => {
      return http.file(`/inventory/objects/import-load`, data)
    },
  })

  const normalizeVerDate = (verDate?: string) => {
    const raw = String(verDate || '').trim()
    if (!raw) return ''

    const dateOnly = DateTime.fromFormat(raw, 'yyyy-LL-dd')
    if (dateOnly.isValid) {
      const now = DateTime.local()
      return dateOnly
        .set({
          hour: now.hour,
          minute: now.minute,
          second: 0,
          millisecond: 0,
        })
        .toFormat("yyyy-LL-dd'T'HH:mm:ss")
    }

    const dateTimeToMinutes = DateTime.fromFormat(raw, "yyyy-LL-dd'T'HH:mm")
    if (dateTimeToMinutes.isValid) {
      return dateTimeToMinutes.set({ second: 0, millisecond: 0 }).toFormat("yyyy-LL-dd'T'HH:mm:ss")
    }

    return raw
  }

  const buildFormData = (data: any) => {
    const formData = new FormData()
    formData.append('import_template_id', String(data.import_template_id))
    formData.append('import_file', data.import_file)
    formData.append('ver_date', normalizeVerDate(data.ver_date))
    return formData
  }

  const upload = async (data: any) => {
    try {
      await mutation.mutateAsync(buildFormData(data))
      addSuccess(trs('itf.imported'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    upload,
  }
}
